import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'
export type Blog = {
  id?: ID
  name?: string
  note?: string
  status?: boolean
}

export type BlogsQueryResponse = Response<Array<Blog>>

export const fields: FieldProps[] = [
  {name: 'title', label: 'Title', required: true, table: true, sortable: true, full: false},
  {
    name: 'description',
    label: 'Descrtiption',
    required: true,
    table: false,
    sortable: true,
    full: false,
  },
  {name: 'slug', label: 'Slug', required: true, table: false, sortable: true, full: false},
  {name: 'image', label: 'ImageUrl', type: 'link', required: true, table: false, sortable: true, full: false},
  {
    name: 'category',
    label: 'Category',
    type: 'select',
    required: true,
    table: true,
    sortable: true,
    full: false,
  },
  {
    name: 'featured',
    label: 'is Featured',
    required: true,
    table: true,
    type: 'switch',
    truthValue: 'Active',
    falseValue: 'Inactive',
    full: false,
  },
  {
    name: 'status',
    label: 'Status',
    type: 'switch',
    truthValue: 'Active',
    falseValue: 'Inactive',
    table: true,
    sortable: true,
    full: false,
  },
  {name: 'content', label: 'Content', table: false, type: 'content', full: true},
]
